import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { requestTagBulkPrint, clearTagBulkPrint } from 'actionCreators';
import PageActionBar from 'components/PageActionBar';
import TagsBulkPrintFilters from './components/TagsBulkPrintFilters';
import MessageBox from 'components/MessageBox';
import Loading from 'components/Loading';
import contentAreaStyles from 'styles/contentArea';
import { push } from 'react-router-redux';
import TagsBulkPrintTable from './components/TagsBulkPrintTable';
import { browserHistory } from 'react-router';

class TagsReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showPrint: false, tags: [], checkedAll: true };
  }

  componentDidMount = () => {
    this.props.clearTagBulkPrint();
    if (this.props.location.search) this.props.requestTagBulkPrint(this.props.location.query);
  }

  componentWillReceiveProps = (nextProps) => {
    const { location: { search, query } } = nextProps;
    let tags;
    if (search !== this.props.location.search) {
      if (search) this.props.requestTagBulkPrint(query);
      else this.props.clearTagBulkPrint();
    }
    if (nextProps.bulkTags.tags && nextProps.bulkTags.tags !== this.props.bulkTags.tags) {
      tags = nextProps.bulkTags.tags.map(tag => ({ ...tag, isChecked: true }));
      this.setState({ tags });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { bulkTags: { loaded, count } } = this.props;
    if (loaded
      && count > 0
      && this.state.showPrint === false
      && prevState.showPrint === false) this.toggleShowPrint(true);
  }

  componentWillUnmount = () => this.props.clearTagBulkPrint();

  onSubmit = query => this.props.push({ pathname: this.props.location.pathname, query })

  handlePrint = () => {
    const tagsToPrint = this.state.tags.filter(tag => tag.isChecked);
    if (tagsToPrint.length > 0) {
      const tags = tagsToPrint.map(tag => ({
        storeNumber: tag.store_number,
        customerName: tag.customer_name,
        poNumber: tag.purchase_order_number,
        quantity: tag.received_quantity,
        dateReceived: tag.date_received,
        tagNumber: tag.tag_number,
        bin: tag.bin,
        itemName: tag.item_name.replace(/\s\s+/g, ' ').trim(),
        pads: tag.pads,
      }));
      const b64Query = btoa(JSON.stringify(tags));
      browserHistory.push({ pathname: '/print-label', search: `?queryData=${JSON.stringify(b64Query)}` });
    }
  }

  handleTagToggle = (tag) => {
    const tags = this.state.tags;
    tags.find(t => t.id === tag.id).isChecked = !tag.isChecked;
    this.setState({ tags, checkedAll: false });
    const noTagsChecked = this.state.tags.every(t => t.isChecked === false);
    if (noTagsChecked === false && this.state.showPrint === false) {
      this.toggleShowPrint(false);
    }
  }

  handleToggleAll = () => {
    const checkedAll = !this.state.checkedAll;
    let newTag;
    const tags = this.state.tags.map((tag) => {
      if (checkedAll) newTag = { ...tag, isChecked: true };
      else newTag = { ...tag, isChecked: !tag.isChecked };
      return newTag;
    });
    this.setState({ tags, checkedAll });
    if (checkedAll) this.toggleShowPrint(true);
    else this.toggleShowPrint(false);
  }

  toggleShowPrint = showPrint => this.setState({ showPrint });

  render = () => {
    const { bulkTags: { loaded, loading, count }, location } = this.props;
    const { showPrint, tags, checkedAll } = this.state;
    return (<Fragment>
      <PageActionBar
        showFiltersBtn={false}
        title="Tags Bulk Print"
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        <div className={contentAreaStyles.contentArea}>
          <TagsBulkPrintFilters
            location={location}
            onSubmit={this.onSubmit}
            showPrint={showPrint}
            handlePrint={this.handlePrint}
          />
          <br />
          {loaded && <TagsBulkPrintTable
            tags={tags}
            showPrint={showPrint}
            checkedAll={checkedAll}
            handleChange={this.handleTagToggle}
            handleToggleAll={() => this.handleToggleAll()}
            toggleShowPrint={this.toggleShowPrint}
          />}
          {(loaded && count <= 0) && <MessageBox
            error
            message="No installations scheduled for the selected options"
          />}
          {loading && <Loading />}
        </div>
      </div>
    </Fragment>);
  }
}

TagsReports.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      date_received: PropTypes.string,
      workroom_id: PropTypes.string,
    }).isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  bulkTags: PropTypes.shape({
    loaded: PropTypes.bool,
    tags: PropTypes.array,
    count: PropTypes.number,
  }),
  requestTagBulkPrint: PropTypes.func.isRequired,
  clearTagBulkPrint: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

export default connect(state => ({
  bulkTags: state.reports.tagsBulkPrint,
}), { requestTagBulkPrint, clearTagBulkPrint, push })(TagsReports);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/tags/index.jsx